<template>
	<component :is="activeComponent"></component>
</template>
<script>
	import { computed, defineAsyncComponent, defineComponent, inject, watch, ref } from 'vue'
	import { useRoute } from 'vue-router'
	import { useFlowControlsStore } from '@/stores/flowControls'
	import { requestIdleCallback, sendAnalytics } from '@/plugins/global'
	import { useLandingPage } from '@/stores/landingPage'
	export default defineComponent({
		name: 'AboutView',
		setup() {
			const route = useRoute()
			const cookies = inject('cookies')
			const stanAnalytics = inject('stanAnalytics')
			const landingPage = useLandingPage()
			const fcStore = useFlowControlsStore()
			const fcpComplete = computed(() => fcStore.fcpComplete)
			const vueGtagInstall = computed(() => fcStore.vueGtagInstall)

			const aboutPageComponents = {
				control: defineAsyncComponent(() => import('@/components/about/AboutPageV6')),
				treatment: defineAsyncComponent(() => import('@/components/about/AboutPageV8')),
				forcedTreatment: defineAsyncComponent(() => import('@/components/about/AboutPageV7')),
			}

			const landingPageVersions = Object.keys(aboutPageComponents)
			const landingPageExperimentCookie = cookies.get('landing-page-v6-vs-v8')

			// Most likely will not even enter (cookie are set by 'feature-flags')
			let pageVersion

			const forced = landingPage.forceExperiment
			if (!forced && !landingPageExperimentCookie) {
				pageVersion = computed(() => {
					const pv = route.query.version || landingPageVersions[Math.floor(Math.random() * landingPageVersions.length)]
					return !pv || !landingPageComponents[pv] ? landingPageVersions[0] : pv
				})
				cookies.set('landing-page-v6-vs-v8', pageVersion.value === 'control' ? 'false' : 'true', '30d')
				cookies.set('landing-page-v6-vs-v8', pageVersion.value === 'control' ? 'false' : 'true', '30d', null, 'stanwith.me')
				cookies.set('landing-page-v6-vs-v8', pageVersion.value === 'control' ? 'false' : 'true', '30d', null, 'stan.store')
			} else if (forced) {
				pageVersion = ref('forcedTreatment')
			} else {
				pageVersion = computed(() => (landingPageExperimentCookie === 'true' ? 'treatment' : 'control'))
			}

			document.body.classList.add('page-version')
			document.documentElement.classList.add('page-version')

			if (pageVersion.value === '2') {
				cookies.set('platform_subscription_priceId', process.env.VUE_APP_STAN_EXPERIMENT_PRICE_ID, '1d')
				cookies.set('platform_subscription_priceId', process.env.VUE_APP_STAN_EXPERIMENT_PRICE_ID, '1d', null, 'stanwith.me')
				cookies.set('platform_subscription_priceId', process.env.VUE_APP_STAN_EXPERIMENT_PRICE_ID, '1d', null, 'stan.store')

				cookies.set('platform_subscription_price', process.env.VUE_APP_STAN_EXPERIMENT_PRICE, '1d')
				cookies.set('platform_subscription_price', process.env.VUE_APP_STAN_EXPERIMENT_PRICE, '1d', null, 'stanwith.me')
				cookies.set('platform_subscription_price', process.env.VUE_APP_STAN_EXPERIMENT_PRICE, '1d', null, 'stan.store')
			} else {
				cookies.set('platform_subscription_priceId', '', '-1')
				cookies.set('platform_subscription_priceId', '', '-1', null, 'stanwith.me')
				cookies.set('platform_subscription_priceId', '', '-1', null, 'stan.store')

				cookies.set('platform_subscription_price', '', '-1')
				cookies.set('platform_subscription_price', '', '-1', null, 'stanwith.me')
				cookies.set('platform_subscription_price', '', '-1', null, 'stan.store')
			}

			const activeComponent = computed(() => {
				return aboutPageComponents[pageVersion.value]
			})

			watch(
				() => vueGtagInstall.value,
				vt => {
					if (vt) {
						requestIdleCallback(() => {
							sendAnalytics(route, cookies, stanAnalytics, pageVersion.value)
						})
					}
				}
			)

			return {
				activeComponent,
			}
		},
	})
</script>
<style lang="scss" scoped></style>
